import '@/javascript/application'

import SignInForm from '@vuejs/views/sign-in/SignInForm'

import { createVueApp } from './createVueApp'

createVueApp(SignInForm).mount('#signInApp')
